const widgetMetricMap: Record<string, string> = {
  "customer acquisition cost": "cac",
  "Impression Share": "imp_share",
  "cost per click": "cpc",
  "Click In": "click_in",
  "Click Out": "clicks_out", //n
  "Click Out/In Ratio": "out_in",
  "Earn Per Click": "epc", //n
  "cost per acquisition": "cpa", //n
  "cost per acquisition player value": "cpa_pv", //n
  "Average Cost Per Acquisition Deal": "average_cost_per_acquisition_deal", //n
  "Conversion Rate": "cvr",
  "First Time Deposit": "ftd", //n
  "Gap Between First Time Deposit and Qualified First Time Deposit": "qftd_ftd", //n
  "Player Value": "pv", //n
  "Net Revenue Per First-Time Depositor": "nrpf", //n
  Profit: "profit",
  Spent: "spend",
  "Total Income": "total_income", //n
  "Revenue Share": "rs", //n
  "Revenue Share Player Value": "rs_pv", //n
  "Average Revenue Share Percentage Deal":
    "average_revenue_share_percentage_deal", //n
};

export const funnelRatioMetricMap: Record<string, string> = {
  "fr-out-in": "out_in",
  "fr-regs-out": "regs_out", //n
  "fr-ftd-regs": "ftd_regs", //n
  "fr-qftd-ftd": "qftd_ftd", //n
};

export const profitAndFirstTimeDepositMetricMap: Record<string, string> = {
  "pf-ftd": "ftd",
  "pf-p": "profit",
};

export default widgetMetricMap;
